import { render, staticRenderFns } from "./EditScrutineer.vue?vue&type=template&id=3cd4ddf2"
import script from "./EditScrutineer.vue?vue&type=script&lang=js"
export * from "./EditScrutineer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports